import React from "react";
import ReactDOM from "react-dom";
import { PropTypes } from "prop-types";
import { SocialShare, WithHostUrl, Link } from "@quintype/components";
import { get } from "lodash";
import { connect } from "react-redux";
import StoryHeader from "./story-templates/shared/story-header";
import TextStoryHeader from "./story-templates/shared/text-story-header";
import StoryPremiumCard from "../../atoms/story-premium-card";
import { STORY_TEMPLATES } from "../../../constants";
import { TextStory } from "./story-templates/text-story-page";
import { PhotoAlbumStory } from "./story-templates/photo-album-story";
import { VideoStory } from "./story-templates/video";
import { PhotoStory } from "./story-templates/photo";
import { ListicleStory } from "./story-templates/listicle-story";
import { LongFormStory } from "./story-templates/long-form";
import { ReviewStory } from "./story-templates/review";
import { LiveBlogStory } from "./story-templates/live-blog";
import { Explainer } from "./story-templates/explainer";
import { SocialShareTemplate } from "./story-templates/shared/social-share";
import { CartoonStory } from "./story-templates/cartoon";
import Tags from "./story-templates/shared/tags";
import { getParentSection } from "../../../data/section";
import AuthorDetail from "./story-templates/shared/author-detail";
import {
  fetchStoryAttributes,
  fetchLatestAtVikatan,
  fetchTrendingStories,
  fetchLatestVideos,
  fetchOneTabLogin,
  fetchvuuklegetCommentCount
} from "../../../api";
import { GA, WebEngage, DeepBI, currentStory, LoadVuukle, EVOLOK, STORY_TRACKING } from "../../../integrations";
import { isPremium } from "../../../data/story";
import SecondaryMenu from "../../atoms/secondary-menu";
import Cookies from "universal-cookie";
import styles from "./styles.m.css";
import { checkMagazineUTM, isGaa, removeBulletImagesFromStory } from "../../utils/utils";
import StorySecondaryCard from "./story-templates/shared/story-secondary-card";
import Media from "react-media";
import RelatedStoryWidget from "../../../components/pages/story/story-templates/shared/related-story-widget";
import LatestStoryWidget from "../../../components/pages/story/story-templates/shared/Latest-story-widget";
import Vuukle from "./story-templates/shared/vuukle";
import { PGAdwithAd, VikatanSticky, VikatanDesktopSticky } from "../../rows/ad-free";
// import { TaboolaAd } from "../../atoms/taboola-ad";
import SpecialBundleCard from "../../atoms/special-bundle-card";
import SmallStoryCardCurve from "../../atoms/small-story-card-with-curve";
import MagazineStory from "./story-templates/magazine-story-page";
import Icon from "../../atoms/icon";
import SubscriptionLinking from "../story/LinkingSubscription";
import { MgidUnderArticleAd } from "../../atoms/mgid-2025/underArticle";
import { RecommendationWidgetInhouse } from "../../atoms/recommedation-widget-inhouse";

const cookies = new Cookies();

function getStoryTemplateComponent(storyTemplate) {
  switch (storyTemplate) {
    case STORY_TEMPLATES.VIDEO:
      return VideoStory;
    case STORY_TEMPLATES.PHOTO:
      return PhotoStory;
    case STORY_TEMPLATES.PHOTO_ALBUM:
      return PhotoAlbumStory;
    case STORY_TEMPLATES.REVIEW:
      return ReviewStory;
    case STORY_TEMPLATES.LISTICLE:
      return ListicleStory;
    case STORY_TEMPLATES.LIVE_BLOG:
      return LiveBlogStory;
    case STORY_TEMPLATES.LONG_FORM:
      return LongFormStory;
    case STORY_TEMPLATES.EXPLAINER:
      return Explainer;
    case STORY_TEMPLATES.CARTOON:
      return CartoonStory;
    default:
      return TextStory;
  }
}

function appendCustomQueryStringUrl(story, view = "normal") {
  let newObj = {};
  newObj = story;
  newObj.pfrom = view;
  return newObj;
}

const magazineGridList = (issueCollection, setClassName, storyId) => {
  const storyMap = issueCollection && getStoriesByLabel(issueCollection);

  const rootMenuGroup =
    issueCollection &&
    Object.keys(storyMap).map((label, idx) => {
      return {
        title: label,
        id: idx,
        items: storyMap[label].map(storyObject => {
          return storyObject;
        })
      };
    });

  const menuTitle =
    issueCollection &&
    rootMenuGroup.map((item, id) => {
      return (
        <div key={id}>
          <div className={styles["card-title"]}>{item.title}</div>
          <div className={`${styles[setClassName]}`}>
            {item.items.map((story, ids) => (
              <div key={ids} className={`${styles["magazine-card"]} ${story.id === storyId && styles["active"]}`}>
                <SmallStoryCardCurve story={story} />
              </div>
            ))}
          </div>
        </div>
      );
    });

  return menuTitle;
};

const episodeGridList = (episodes, storyId, magazineCard) => {
  const episodeList =
    episodes &&
    episodes
      .map((story, id) => {
        if (storyId !== story.id) {
          return (
            <div key={id} className={`${styles["magazine-card"]}`}>
              <SmallStoryCardCurve story={story} magazineCard={magazineCard} />
            </div>
          );
        }
      })
      .filter(i => i);

  return episodeList;
};

class StoryTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      relatedStories: [],
      visualStories: null,
      trendingStories: [],
      access: null,
      socialView: false,
      width: global.innerWidth,
      showModal: !!cookies.get("userPaid"),
      activePaywall: this.props.activePaywall,
      activeStdPaywall: this.props.activeStdPaywall,
      jshow: false,
      userType: "F",
      show_rfm: false,
      evAccess: "REQUIRE_LOGIN",
      evAudioAccess: "PREMIUM_ACCESS",
      evSegments: [],
      latestVideos: null,
      HideFooterElements: false,
      commentsCount: {}
    };
    this.floatingbar = React.createRef();
    this.handleClickView = this.handleClickView.bind(this);
    this.myRef = React.createRef();
  }

  componentDidMount() {
    const { index } = this.props;

    const storyId = get(this.props, ["story", "id"], null);

    global.userPromise.catch(() => null).then(user => {
      user && this.setState({ userType: user.userType });
    });

    if (index === 0 && isPremium(this.props.story)) {
      currentStory.storyCookie(this.props.story, "");
    }

    if (index === 0) {
      this.setState({
        show_rfm: !this.state.show_rfm
      });
      const magazineEntity = get(this.props, ["magazineEntity"], null);

      EVOLOK.loadScript(
        "story-page",
        {
          story: this.props.story,
          collection: { ...this.props.issueCollection, magazineEntity: magazineEntity }
        },
        this.handleMeteringSuccess
      );
    }

    if (global && global.matchMedia("(min-width: 768px)").matches && this.props.story["story-template"] === "video") {
      fetchLatestVideos(0, 5, { "exclude-story-ids": storyId })
        .then(response => {
          this.setState({ latestVideos: response && response });
        })
        .catch(console.error);
    }
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        this.setState({ commentsCount: res.data });
      })
      .catch(console.error);
  }

  handleMeteringSuccess = response => {
    if (!isGaa()) {
      this.setState({
        evAccess: response.result,
        evSegments: response.segments,
        evAudioAccess: response.result
      });
    } else {
      this.setState({
        evAccess: "ALLOW_ACCESS"
      });
    }
  };

  componentWillReceiveProps(nextState) {
    if (this.state.activeStdPaywall !== nextState.activeStdPaywall) {
      this.setState({ activeStdPaywall: false });
    }
  }

  expandComments = () => {
    this.setState({
      HideFooterElements: false
    });
    this.myRef.current.scrollIntoView({ behavior: "smooth", top: "-160px" });
  };
  handleExpandStory = () => {
    this.setState({
      show_rfm: !this.state.show_rfm
    });
    this.props.firePageView(this.props.story, true);
    global.app.maybeSetUrl(
      "/" + this.props.story.slug + "?pfrom=latest-infinite",
      get(this.props, ["story", "seo", "meta-title"], this.props.story.headline)
    );
    this.props.checkInfoStatus({ id: this.props.story.id, status: true });

    const magazineEntity = get(this.props, ["magazineEntity"], null);
    EVOLOK.loadScript(
      "story-page",
      {
        story: this.props.story,
        collection: { ...this.props.issueCollection, magazineEntity: magazineEntity }
      },
      this.handleMeteringSuccess
    );
  };

  handleClickView() {
    window.scrollTo({
      top: this.floatingbar.current.offsetTop - 120,
      behavior: "smooth"
    });
  }

  CloseStdPaywall(args) {
    this.props.actionhandleStdActivePaywall(false);
  }

  handleCloseDatawall() {
    this.setState({
      show_rfm: !this.state.show_rfm
    });
  }

  // handleScrollComment = () => {
  //   this.setState({
  //     HideFooterElements: false
  //   });
  //   this.myRef.current.scrollIntoView({ behavior: "smooth", top: "-120px" });
  // };

  render() {
    const storyTemplate = get(this.props, ["story", "story-template"]);
    const story = removeBulletImagesFromStory(get(this.props, ["story"], null));

    if (!story) {
      return null;
    }
    const config = get(this.props, ["config"]);
    const episodes = get(this.props, ["episodes"]);
    const versionStat = get(story, ["pfrom"], null);
    const singleCard = get(story, ["cards"], []);

    const singleelementWithcard = singleCard
      .map((item, i) => {
        let params = { ...item };
        params["story-elements"] = [item["story-elements"][0]];
        if (i === 0) {
          return params;
        }
      })
      .filter(i => i);

    const renderSocialMedia = (className = "", stickyShare) => (
      <SocialShare
        className={className}
        template={SocialShareTemplate}
        fullUrl={story.url}
        title={story.headline}
        handleClickView={this.handleClickView}
        hashtags={
          story.tags &&
          story.tags
            .filter(tag => tag !== null)
            .map(tag => tag.name)
            .toString()
        }
        story={story}
        stickyShare={stickyShare}
      />
    );

    const renderHeaderCard = (className = "", readMore = true, cartoon = true, readTimeshow = true) => {
      return (
        <StoryHeader
          subheadline={false}
          config={config}
          story={story}
          className={`${className} js-story-header`}
          episodes={episodes}
          readMore={readMore}
          cartoon={cartoon}
          readTimeshow={readTimeshow}
        />
      );
    };

    const renderTextStoryHeaderCard = ({ className, readMore } = { className: "", readMore: true }) => (
      <TextStoryHeader
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
        readMore={readMore}
      />
    );

    const renderSecondaryCard = ({ className } = { className: "" }) => (
      <StorySecondaryCard
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
      />
    );

    const renderTags = () => <Tags tags={story.tags} className={styles.tags} />;

    const renderAuthorDetails = () => (
      <AuthorDetail
        authors={story.authors}
        config={config}
        contributors={story.contributors}
        className={styles["author-detail"]}
      />
    );

    const renderRelatedArticle = props => {
      const trendingStories = get(this.props, ["trendingStories"], []);
      const storyId = get(this.props, ["story", "id"], "");
      const filteredTrendingStories =
        trendingStories && trendingStories.length > 0 && trendingStories.filter(item => item.id !== storyId);
      const relatedStoriesCollection = {
        name: "இந்தக் கட்டுரைகளையும் படிக்கலாமே!",
        trending:
          filteredTrendingStories &&
          filteredTrendingStories.length > 0 &&
          filteredTrendingStories.map(data => ({ item: data.story }))
      };

      return (
        <React.Fragment>
          <RelatedStoryWidget
            className={`${styles["related-stories"]} js-related-stories`}
            collection={relatedStoriesCollection}
          />
        </React.Fragment>
      );
    };

    const leftSidebarRestrict = () => {
      const issueCollection = get(this.props, ["issueCollection"]);
      const episodes = get(this.props, ["episodes"], null);

      if (!checkMagazineUTM() && episodes) {
        return (
          <React.Fragment>
            <div className={styles["card-title"]}>மற்ற எபிசோடுகள்</div>
            <div className={styles["magazine-card-grid-wrapper"]}>
              {episodeGridList(this.props.episodes, this.props.story.id)}
            </div>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            {magazineGridList(issueCollection, "magazine-card-grid-wrapper", this.props.story.id)}
          </React.Fragment>
        );
      }
    };

    const renderSidebar = (adshow = true) => {
      const issueCollection = get(this.props, ["issueCollection"]);
      const episodes = get(this.props, ["episodes"], null);
      const magazineView = get(issueCollection, ["magazineView"]);
      const storyId = get(this.props, ["story", "id"], "");
      const story = get(this.props, ["story"], "");
      return (episodes || issueCollection) && magazineView ? (
        <div className={`${styles["lefts-side-menu"]} hidden-desktop`}>{leftSidebarRestrict()}</div>
      ) : (
        <div>
          <div className={styles["right-side-panel"]}>
            <aside className={`${styles["right-sidebar"]} ${styles.sidebar}`}>
              <div className={styles["manifest-wrapper"]}>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLScA9cvhWoGra2XKSxtjR7IZRsnCEOl21beMOMwArKi9yhMO8Q/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="https://media.vikatan.com/vikatan/2026-03-03/qifb682k/Manifestobannermobile.png" alt="" />
                </a>
              </div>
              <Media query="(min-width:768px)">
                <PGAdwithAd
                  adId={`Vikatan2023_Desktop_AP_RightATF_336x280`}
                  adSize={[[336, 280], [300, 250]]}
                  minHeight={280}
                  adDivId={`div-ad-desk-3849069-1690281136-2_${storyId}`}
                  class="ad_300_250"
                  story={story}
                  config={this.props.config}
                />
              </Media>

              <Media query="(min-width:768px)">
                <div className="hidden-mobile">
                  {storyTemplate === "video"
                    ? this.state.latestVideos && (
                        <LatestStoryWidget
                          className={`${styles["related-stories"]} js-related-stories`}
                          collection={this.state.latestVideos}
                          type="videos"
                        />
                      )
                    : this.props.latestStories && (
                        <LatestStoryWidget
                          className={`${styles["related-stories"]} js-related-stories`}
                          collection={this.props.latestStories}
                          type="normal"
                        />
                      )}
                </div>
              </Media>

              {adshow && (
                <Media query="(min-width:768px)">
                  <PGAdwithAd
                    adId={`Vikatan2023_Desktop_AP_RightMID_336x280`}
                    adSize={[[336, 280], [300, 250]]}
                    minHeight={280}
                    adDivId={`div-ad-desk-3849069-1690281136-1_${storyId}`}
                    class="ad_300_250"
                    story={story}
                    config={this.props.config}
                  />
                </Media>
              )}
            </aside>
          </div>
          {this.state.userType === "P" || this.state.userType === "T" || this.state.userType === "R" ? (
            <div />
          ) : (
            <Media query="(min-width:768px)">
              <SpecialBundleCard className="feed-page" config={config} />
            </Media>
          )}
          {adshow && (
            <Media query="(min-width:768px)">
              <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
                {this.state.userType === "P" || this.state.userType === "T" || this.state.userType === "R" ? (
                  <SpecialBundleCard className="feed-page" config={config} />
                ) : (
                  <PGAdwithAd
                    adId={`Vikatan2023_Desktop_AP_RHS_300x600`}
                    adSize={[[300, 600]]}
                    minHeight={600}
                    adDivId={`div-ad-desk-3849069-1690281136-0_${storyId}`}
                    class="ad-300x600"
                    story={story}
                    config={this.props.config}
                  />
                )}
              </div>
            </Media>
          )}
        </div>
      );
    };

    const renderarticleFooter = (isOpen = false, cardScroll) => {
      return (
        <div className="js-story-footer">
          {this.props.config && this.props.config.AllStoriesFree === true ? (
            ""
          ) : !isOpen && !isGaa() ? (
            <ev-engagement />
          ) : (
            ""
          )}

          <div className="hidden-desktop">
            <div className={styles["manifest-wrapper"]}>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScA9cvhWoGra2XKSxtjR7IZRsnCEOl21beMOMwArKi9yhMO8Q/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="https://media.vikatan.com/vikatan/2026-03-03/qifb682k/Manifestobannermobile.png" alt="" />
              </a>
            </div>
          </div>

          <RecommendationWidgetInhouse story={story} />

          <div className={styles["vikatan-watermark"]}>
            <Icon type="vikatan" />
          </div>

          {!isOpen &&
            !this.state.HideFooterElements && (
              <div className={styles["Vuukle-comments"]}>
                <strong>
                  இதில் பின்னூட்டம் இடுபவர்களின் கருத்துகள் அவரவர் தனிப்பட்ட கருத்துகள். அவற்றுக்கு விகடன்
                  பொறுப்பேற்காது.
                  <br />
                  <br />
                </strong>
                <strong>
                  எனினும், கண்ணியத்தையும் மரியாதையையும் காப்பது அனைவரின் பொறுப்பு. தனிப்பட்ட தாக்குதல், அவதூறு அல்லது
                  வெறுப்பைத் தூண்டும் கருத்துகளை விகடன் அனுமதிக்காது.
                </strong>
                <br />
                <br />
                <strong>
                  அத்தகைய கருத்துகள் Moderation பகுதிக்குச் செல்லக்கூடும் அல்லது நிராகரிக்கப்படலாம் என்பதைத் தயவுசெய்து
                  புரிந்துகொள்ளுங்கள்.
                </strong>
              </div>
            )}

          <div
            ref={this.myRef}
            className={`${!this.state.HideFooterElements ? styles["show-vuukle"] : styles["hide-vuukle"]} test-slot`}
          >
            <Vuukle story={story} vuukleConfig={this.props.config.vikatanHosts} />
          </div>
        </div>
      );
    };

    const renderFooter = (isOpen = false, cardScroll) => {
      return (
        <div className="js-story-footer">
          {/* {!isPremium(this.props.story) && !isOpen && renderRelatedArticle()} */}
          {!isOpen && renderTags()}
          <SubscriptionLinking />
          {!isPremium(this.props.story) && <MgidUnderArticleAd />}
          {/* <div className="taboola-outer">
            <TaboolaAd
              config={{
                mode: "thumbnails-a",
                id: "taboola-below-article-thumbnails",
                placement: "Below Article Thumbnails"
              }}
              url={global && global.location && global.location.href}
              className={"taboola-article"}
              directory={"article"}
              flush={true}
            />
          </div> */}
          <div className={styles["space-before-next-story"]} />
        </div>
      );
    };

    const renderFooterMagazine = () => {
      const issueCollection = get(this.props, ["issueCollection"]);
      const magazineView = get(issueCollection, ["magazineView"]);
      return magazineView && issueCollection ? (
        <div className={styles["footer-magazine-wrapper"]}>
          <div className={styles["footer-list-mag"]}>{leftSidebarRestrict()}</div>
        </div>
      ) : (
        <div />
      );
    };

    const renderPremiumCard = () => {
      return <React.Fragment>{isPremium(this.props.story) && <StoryPremiumCard />}</React.Fragment>;
    };

    const GetStoryScrollPercentage = percentage => {
      this.props.GetScrollValue(percentage);
    };

    const renderProps = {
      renderSocialMedia,
      renderTags,
      renderAuthorDetails,
      renderHeaderCard,
      renderTextStoryHeaderCard,
      renderSidebar,
      renderarticleFooter,
      renderFooter,
      renderPremiumCard,
      renderSecondaryCard,
      renderRelatedArticle,
      renderFooterMagazine,
      GetStoryScrollPercentage
    };

    const issueCollectionObj = get(this.props, ["issueCollection"]);
    const magazineView = get(issueCollectionObj, ["magazineView"]);

    const StoryTemplateComponent =
      magazineView && (episodes || issueCollectionObj)
        ? MagazineStory
        : getStoryTemplateComponent(story["story-template"]);
    return (
      <StoryTemplateComponent
        story={{
          ...story,
          cards:
            config && config.AllStoriesFree === true
              ? story.cards
              : isPremium(story) && this.state.evAccess !== "ALLOW_ACCESS" && !isGaa()
                ? singleelementWithcard
                : story.cards
        }}
        config={config}
        episodes={episodes}
        {...renderProps}
        fireVirtualPageView={this.props.firePageView}
        READMORE_ENABLE={this.props.READMORE_ENABLE}
        relatedStories={this.state.relatedStories}
        checkInfoStatus={this.props.checkInfoStatus}
        versionStat={versionStat}
        handleExpandStory={this.handleExpandStory}
        index={this.props.index}
        evAccess={this.state.evAccess}
        evAudioAccess={this.state.evAudioAccess}
        expandComments={this.expandComments}
        clientSideRendered={this.props.clientSideRendered}
        issueCollectionObj={issueCollectionObj}
      />
    );
  }
}

export class StoryFeedPageBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      story,
      episodes,
      config,
      metypeConfig,
      firePageView,
      issueCollection,
      READMORE_ENABLE,
      index,
      checkInfoStatus,
      versionStat,
      actionhandleActivePaywall,
      activePaywall,
      activeStdPaywall,
      actionhandleStdActivePaywall,
      GetScrollValue,
      latestStories,
      trendingStories,
      paywallPlans,
      razaorpayKey,
      magazineEntity,
      clientSideRendered
    } = this.props;

    let readmoreStat = READMORE_ENABLE;

    const sections = [get(story, ["sections", 0], {})];
    const parentSection = getParentSection(sections[0]);
    if (parentSection) {
      sections.unshift(parentSection);
    }
    const subsection = get(sections, [1, "name"]) || "";

    return (
      <div className={`js-content-insights-${story.id}`}>
        <div data-subsection={subsection} className="subsection-event" />
        <StoryTemplate
          story={story}
          config={config}
          episodes={episodes}
          metypeConfig={metypeConfig}
          paywallPlans={paywallPlans}
          razaorpayKey={razaorpayKey}
          firePageView={firePageView}
          issueCollection={issueCollection}
          READMORE_ENABLE={readmoreStat}
          checkInfoStatus={checkInfoStatus}
          versionStat={versionStat}
          index={index}
          actionhandleActivePaywall={actionhandleActivePaywall}
          activePaywall={activePaywall}
          actionhandleStdActivePaywall={actionhandleStdActivePaywall}
          GetScrollValue={GetScrollValue}
          activeStdPaywall={activeStdPaywall}
          latestStories={latestStories}
          trendingStories={trendingStories}
          magazineEntity={magazineEntity}
          clientSideRendered={clientSideRendered}
        />
      </div>
    );
  }
}
StoryFeedPageBase.propTypes = {
  episodes: StoryHeader.propTypes.episodes,
  story: TextStory.propTypes.story,
  config: PropTypes.object,
  metypeConfig: PropTypes.object,
  recentStory: PropTypes.object,
  paywallPlans: PropTypes.object,
  razaorpayKey: PropTypes.object,
  firePageView: PropTypes.func,
  issueCollection: PropTypes.shape({
    id: PropTypes.number
  }),
  READMORE_ENABLE: PropTypes.bool,
  index: PropTypes.number,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  userType: PropTypes.string,
  actionhandleActivePaywall: PropTypes.func,
  activePaywall: PropTypes.bool,
  visualStories: PropTypes.shape(),
  actionhandleStdActivePaywall: PropTypes.func,
  GetScrollValue: PropTypes.func,
  activeStdPaywall: PropTypes.bool,
  latestStories: PropTypes.shape(),
  trendingStories: PropTypes.shape(),
  magazineEntity: PropTypes.shape(),
  clientSideRendered: PropTypes.bool
};

StoryTemplate.propTypes = {
  episodes: StoryHeader.propTypes.episodes,
  story: PropTypes.shape(),
  config: PropTypes.object,
  metypeConfig: PropTypes.object,
  recentStory: PropTypes.object,
  paywallPlans: PropTypes.object,
  razaorpayKey: PropTypes.object,
  firePageView: PropTypes.func,
  issueCollection: PropTypes.shape({
    id: PropTypes.number
  }),
  READMORE_ENABLE: PropTypes.bool,
  index: PropTypes.number,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  userType: PropTypes.string,
  actionhandleActivePaywall: PropTypes.func,
  activePaywall: PropTypes.bool,
  visualStories: PropTypes.shape(),
  actionhandleStdActivePaywall: PropTypes.func,
  GetScrollValue: PropTypes.func,
  activeStdPaywall: PropTypes.bool,
  latestStories: PropTypes.shape(),
  trendingStories: PropTypes.shape(),
  magazineEntity: PropTypes.shape()
};

class WrapperStoryIntersectionObserverBase extends React.Component {
  constructor(props) {
    super(props);
    this.storyRef = React.createRef();
  }

  componentDidMount() {
    this.intersectionObserver =
      global.IntersectionObserver &&
      new global.IntersectionObserver(
        entries => {
          // There will be only One target as we are implementing one Intersection Observer for every Story
          if (entries[0].isIntersecting === true) {
            this.intersectionObserver && this.intersectionObserver.disconnect();
          }
        },
        {
          rootMargin: "0px"
        }
      );
    /* eslint-disable react/no-find-dom-node */
    this.intersectionObserver.observe(ReactDOM.findDOMNode(this.storyRef.current));
  }
  componentWillUnmount() {
    this.intersectionObserver && this.intersectionObserver.disconnect();
  }
  render() {
    return <StoryFeedPageBase {...this.props} ref={this.storyRef} />;
  }
}
// Dispatch the action to update the store from the Intersection Observer
const mapDispatchToProps = dispatch => {
  return {
    updateRemainingStoriesCounter: function(remainingStoriesCount) {
      dispatch({
        type: "UPDATE_STORIES_READ_STATS",
        remainingStoriesCount: remainingStoriesCount
      });
    }
  };
};
const WrapperStoryIntersectionObserver = connect(
  state => state,
  mapDispatchToProps
)(WrapperStoryIntersectionObserverBase);

const getStoriesByLabel = collection => {
  return collection.items.filter(({ story = {} }) => story.headline && story.url).reduce((storyMap, item) => {
    const label = get(item, ["associated-metadata", "label"], "மற்றவை");
    if (storyMap[label]) {
      storyMap[label].push(item.story);
    } else {
      storyMap[label] = [item.story];
    }
    return storyMap;
  }, {});
};

const generateSecondaryMenu = (issueCollection, magazine) => {
  const storyMap = issueCollection && getStoriesByLabel(issueCollection);
  const rootMenuGroup = Object.keys(storyMap).map((label, idx) => {
    return {
      title: label,
      id: idx,
      items: storyMap[label].map(storyObject => {
        return {
          title: storyObject["headline"],
          url: storyObject["url"]
        };
      })
    };
  });

  const firstElement = magazine.name && (
    <Link href={issueCollection.pagePath} className={styles["magazine-name"]}>
      {magazine.name.replace(/\(\w+\)/, "")}
    </Link>
  );
  const root = {
    items: rootMenuGroup
  };
  return (
    <SecondaryMenu
      menuGroup={root}
      className={styles["magazine-secondary-menu"]}
      firstElement={firstElement}
      communityColor={magazine.color}
    />
  );
};

const googleApiClientId = "962641865525-qk3eqej1shfi589ahq1enclp2i5soen0.apps.googleusercontent.com";
const allowedReferrers = ["www.vikatan.com", "vikatan.com", "beta.vikatan.com", "localhost", "localhost:3000"];

export class StoryFeedPage extends React.Component {
  constructor(props) {
    super(props);
    this.firePageView = this.firePageView.bind(this);
    this.cachedFirstPageStories = [];
    this.MAX_ALREADY_STORIES_READ_COUNT = 5;
    this.state = {
      READMORE_ENABLE: false,
      visibleStories: [],
      relatedStories: [],
      latestStories: null,
      trendingStories: null,
      userType: "F",
      activePaywall: true,
      activeStdPaywall: true,
      user: null,
      nextStory: [],
      storyUrls: [],
      isVisible: false,
      EvAccess: "REQUIRE_LOGIN",
      sequnce: 0,
      rndNInt: Math.floor(Math.random() * 11) + 1,
      rndPInt: Math.floor(Math.random() * 11) + 1,
      scroll: 0, // Expecting a value between 0 and 100
      triggeredThresholds: new Set() // Track triggered thresholds
    };
    this.checkInfoStatus = this.checkInfoStatus.bind(this);
    this.scrollFunction = this.scrollFunction.bind(this);
    this.UpdateStateScroll = this.UpdateStateScroll.bind(this);
    this.timer = this.timer.bind(this);
  }
  // Method to update scroll and check thresholds
  UpdateStateScroll = percentage => {
    const roundedPercentage = Math.round(percentage);
    // console.log("Rounded percentage value:", roundedPercentage);

    this.setState(
      {
        scroll: roundedPercentage
      },
      this.checkThresholds
    );
  };

  // Method to check thresholds and trigger STORY_TRACKING.ping with static values
  checkThresholds = () => {
    const ranges = [
      { min: 25, max: 49, value: 25 },
      { min: 50, max: 74, value: 50 },
      { min: 75, max: 95, value: 75 },
      { min: 96, max: 100, value: 100 }
    ];

    const { scroll, triggeredThresholds } = this.state;
    const newTriggeredThresholds = new Set(triggeredThresholds);

    ranges.forEach(({ min, max, value }) => {
      const thresholdKey = `${min}-${max}`;

      if (scroll >= min && scroll <= max && !newTriggeredThresholds.has(thresholdKey)) {
        // console.log(`Triggering for range ${min}% - ${max}%, sending ${value}%`);
        newTriggeredThresholds.add(thresholdKey);
        this.timer(value);
      }
    });

    this.setState({
      triggeredThresholds: newTriggeredThresholds
    });
  };
  timer = value => {
    if (value !== undefined) {
      const story = get(this.props, ["data", "story"]);
      STORY_TRACKING.ping(value, story);
    } else {
      console.log("No valid value to send in ping.");
    }
  };

  isStoryNotReadYet(storyId) {
    if (!global.localStorage) {
      return true;
    }

    const alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    return !alreadyReadStories.includes(storyId);
  }

  markStoryAsRead(storyId) {
    if (!global.localStorage) {
      return null;
    }

    if (isGaa()) {
      return null;
    }

    let alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    if (alreadyReadStories.length >= this.MAX_ALREADY_STORIES_READ_COUNT) {
      alreadyReadStories = [];
    }
    let alreadyReadStoriesSet = new Set(alreadyReadStories);
    alreadyReadStoriesSet.add(storyId);
    global.localStorage.setItem("alreadyReadStories", JSON.stringify(Array.from(alreadyReadStoriesSet)));
    global.localStorage.removeItem("premiumStoriesRead");
  }

  collectioshema = stories => {
    return stories
      ? stories.map(data => ({
          story: appendCustomQueryStringUrl(data.story),
          id: data.id,
          score: data.score,
          type: data.type,
          item: data.item
        }))
      : [];
  };

  handleLoginPromise = new Promise((resolve, reject) => {
    console.log("login promise");
    if (global && global.GaaMetering && typeof global.GaaMetering.getLoginPromise === "function") {
      global.GaaMetering.getLoginPromise().then(() => {
        // Open a login window for existing users to login.
        const curUrl = global && global.location && global.location.href;
        const loginWindow = window.open(`https://login.vikatan.com?redirect_url=${encodeURIComponent(curUrl)}`);

        // Wait for the login window to send a message with userState for the user.
        global.addEventListener(
          "message",
          function(message) {
            if (loginWindow === message.source) {
              resolve(message.data);
            }
          },
          false
        );
      });
    }
  });

  showPaywall() {
    const curUrl = global && global.location && global.location.href;
    console.log("Example: show paywall");
    global.location.href = `https://store.vikatan.com/gns-payment?redirect_url=${encodeURIComponent(curUrl)}`;
  }

  // Callback that must unlock the current article which is called when Google is
  // granting Extended Access to the user.
  // Do not copy the implementation for the callback and see documentation for your own implementation at:
  // https://developers.google.com/news/subscribe/extended-access/integration-steps/web-implementation#handle-extended-access-grants
  unlockArticle() {
    console.log("Example: unlock article");
    document.documentElement.classList.add("open-paywall");
  }

  registerUserPromise = new Promise((resolve, reject) => {
    console.log("register promise");

    if (global && global.GaaMetering && typeof global.GaaMetering.getGaaUserPromise === "function") {
      global.GaaMetering.getGaaUserPromise().then(gaaUser => {
        console.log("register promise", gaaUser);
        const gaaUserDecoded = gaaUser.credential;
        fetchOneTabLogin(gaaUserDecoded)
          .then(response => {
            const current = new Date();
            const nextYear = new Date();
            nextYear.setFullYear(current.getFullYear() + 1);
            const resData = get(response, ["data"]);
            const guid = get(response, ["data", "guid"]);
            const evSS = get(response, ["data", "mainSession", "sessionId"]);
            cookies.set("ev-guid", guid, { path: "/", domain: ".vikatan.com", expires: nextYear });
            cookies.set("ev_ss", evSS, { path: "/", domain: ".vikatan.com", expires: nextYear });
            global.localStorage.setItem("evolok:ev_session", JSON.stringify(resData));
            const userState = {
              id: gaaUserDecoded,
              registrationTimestamp: Math.round(Date.now() / 1000),
              granted: false,
              grantReason: "SUBSCRIBER"
            };
            resolve(userState);
          })
          .catch(console.error);
      });
    }
  });

  publisherEntitlementPromise = new Promise(resolve => {
    // Example body of the promise returning a publisherEntitlement object
    const publisherEntitlement = {
      granted: false,
      grantReason: "SUBSCRIBER"
    };
    resolve(publisherEntitlement);
  });

  componentDidMount() {
    window.addEventListener("scroll", this.scrollFunction);
    const current = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(current.getDate() + 28);
    const story = get(this.props, ["data", "story"], {});
    global.localStorage && global.localStorage.setItem("story-view", story.id);
    this.markStoryAsRead(story.id);
    this.firePageView();
    this.timer();
    global.userPromise.catch(() => null).then(user => {
      let userTypeStat = get(user, ["userType"], "F");
      let userId = get(user, ["userId"], null);
      let userJoinDate = get(user, ["userJoinDate"], null);
      const userStatObj = {};
      userStatObj.granted = userTypeStat === "P";
      LoadVuukle.register(story, this.props.config.vikatanHosts);
      if (userId) {
        userStatObj.id = userId;
        userStatObj.registrationTimestamp = userJoinDate;
        userStatObj.grantReason = "SUBSCRIBER";
      }

      this.setState({ userType: userTypeStat, user: user });
      global &&
        global.GaaMetering.init({
          googleApiClientId: googleApiClientId,
          allowedReferrers: allowedReferrers,
          userState: userStatObj,
          unlockArticle: this.unlockArticle,
          showPaywall: this.showPaywall,
          registerUserPromise: this.registerUserPromise,
          handleLoginPromise: this.handleLoginPromise,
          publisherEntitlementPromise: this.publisherEntitlementPromise
        });
    });

    const storyId = get(this.props, ["data", "story", "id"], null);
    if (
      global &&
      global.matchMedia("(min-width: 768px)").matches &&
      this.props.data.story["story-template"] !== "video"
    ) {
      fetchLatestAtVikatan(0, 5, { "exclude-story-ids": storyId })
        .then(response => {
          this.setState({ latestStories: response });
        })
        .catch(console.error);
    }
    fetchTrendingStories(0, 7)
      .then(response => {
        this.setState({ trendingStories: response && response.items });
      })
      .catch(console.error);
  }

  firePageView = (story = this.props.data.story, firedFromInfinite = false) => {
    if (this.props.config.disableAds) {
      return;
    }
    const issueCollection = get(this.props, ["data", "issueCollection"], null);

    currentStory.setStorydata(story, issueCollection);

    fetchStoryAttributes(story)
      .then(result => {
        GA.registerPageView(this.props.pageType, {
          story: { ...story, collections: result.collections },
          collection: issueCollection,
          infiniteTagRequired: firedFromInfinite
        });
        DeepBI.registerPageView({ story: { ...story, collections: result.collections }, glance: false });
        WebEngage.registerPageView({ story, triggerArticleEvent: !firedFromInfinite });
      })
      .catch(console.error);
  };

  checkInfoStatus = stat => {
    const story = get(this.props, ["data", "story"]);
    this.setState({
      sequnce: 0
    });
    if (stat.status === true) {
      this.sendQlitics(story);
      this.setState({
        visibleStories: [...this.state.visibleStories, stat.id]
      });
    } else {
      let filteredArray = this.state.visibleStories.filter(item => item !== stat.id);
      this.setState({
        visibleStories: filteredArray
      });
    }
  };

  sendQlitics = (story = {}) => {
    const { registerStoryView } = require("@quintype/framework/client/analytics");
    registerStoryView(story.id);
  };

  handleActivePaywall = args => {
    this.setState({
      activePaywall: args
    });
  };

  handleSetStoryUrls = args => {
    this.setState({
      storyUrls: args
    });
  };

  handleStdActivePaywall = args => {
    this.setState({
      activeStdPaywall: args
    });
  };

  GetScrollValue = args => {
    this.UpdateStateScroll(args);
  };

  scrollFunction() {
    if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
      this.setState({ isVisible: true });
    } else {
      this.setState({ isVisible: false });
    }
  }

  handleClickEvents() {
    DeepBI.PingIplQuiz("FreeTrailWidgetClicked");
  }

  handleplayClickEvents() {
    DeepBI.PingIplQuiz("FloatingPlayWidgetClicked");
  }
  render() {
    const metypeConfig = get(this.props, ["data", "publisherConfig", "metypeConfig"]);
    const paywallPlans = get(this.props, ["data", "publisherConfig", "paywallPlans"]);
    const razaorpayKey = get(this.props, ["data", "publisherConfig", "razarpayKey"]);
    const issueCollection = get(this.props, ["data", "issueCollection"], []);
    const magazineView = get(issueCollection, ["magazineView"]);
    const magazineEntity = get(this.props, ["data", "magazineEntity"]);
    // const { userType, trendingStories, rndNInt, rndPInt } = this.state;
    const { userType } = this.state;
    const story = get(this.props, ["data", "story"]);
    const episodes = get(this.props, ["data", "episodes"], []);
    // const nextStoryUrl = get(trendingStories, [rndNInt, "story", "url"], null);
    // const prevStoryUrl = get(trendingStories, [rndPInt, "story", "url"], null);
    const storyId = get(this.props, ["data", "story", "id"]);

    return (
      <React.Fragment>
        {!checkMagazineUTM() && episodes ? (
          <div />
        ) : (
          <div className={styles["sticky-secondary-menu"]}>
            {magazineView &&
            issueCollection &&
            magazineEntity &&
            get(issueCollection, ["magazineEnName"]) !== "Vikatan Digital Exclusive" ? (
              <div className={styles["secondary-menu"]}>{generateSecondaryMenu(issueCollection, magazineEntity)}</div>
            ) : (
              <div />
            )}
          </div>
        )}

        {/* <div className={styles["fixedUrl"]}>
          {nextStoryUrl && (
            <div className={styles["next-event"]}>
              <Link
                callback={() => {
                  if ("ga" in window) {
                    window.ga("send", "event", "Next Story", "Clicked", nextStoryUrl);
                  }
                  if ("gtag" in window) {
                    window.gtag("event", "Next Story", {
                      event_category: "Clicked",
                      event_label: nextStoryUrl
                    });
                  }
                }}
                href={`${nextStoryUrl}?pfrom=next-story-btn`}
                className={styles["next"]}
              >
                <Icon type="angle-right" className={styles["next-icon"]} />
              </Link>
            </div>
          )}
          {prevStoryUrl && (
            <div className={styles["prev-event"]}>
              <Link
                href={`${prevStoryUrl}?pfrom=prev-story-btn`}
                className={styles["prev"]}
                callback={() => {
                  // if ("ga" in window) {
                  //   window.ga("send", "event", "Previous story", "Clicked", prevStoryUrl);
                  // }
                  if ("gtag" in window) {
                    window.gtag("event", "Previous story", {
                      event_category: "Clicked",
                      event_label: prevStoryUrl
                    });
                  }
                }}
              >
                <Icon type="angle-left" className={styles["prev-icon"]} />
              </Link>
            </div>
          )}
        </div> */}

        {/* <div className={`${styles["sticky-bottom-section"]} hidden-desktop`} onClick={this.handleClickEvents}>
          <a href="https://onelink.to/qhkkkz" rel="noopener noreferrer" target="_blank">
            Get 30 days free Trial on App
          </a>
        </div> */}

        {/* <div className={`${styles["sticky-right-section"]} hidden-desktop`} onClick={this.handleplayClickEvents}>
          <a href="https://onelink.to/xe47ta" rel="noopener noreferrer" target="_blank">
            <img
              alt="Vikatan"
              src="https://media.vikatan.com/vikatan/2025-06-10/g8o9cvez/Vikatanplaylogo.png?format=webp&w=300&q=100"
              className={styles["brand-logo"]}
              width="80px"
              height="50px"
            />
          </a>
        </div> */}

        <div
          className={`main-page ${styles["base"]} ${
            isPremium(story) || issueCollection ? styles["premium-article"] : styles["nonpremium-article"]
          } js-story-main-container`}
        >
          <div />

          <WithHostUrl>
            {({ currentHostUrl }) => (
              <WrapperStoryIntersectionObserver
                config={this.props.config}
                metypeConfig={metypeConfig}
                firePageView={() => this.firePageView(this.props.data.story)}
                READMORE_ENABLE={this.state.READMORE_ENABLE}
                checkInfoStatus={this.checkInfoStatus}
                versionStat={"v4"}
                activePaywall={this.state.activePaywall}
                actionhandleActivePaywall={this.handleActivePaywall}
                activeStdPaywall={this.state.activeStdPaywall}
                actionhandleStdActivePaywall={this.handleStdActivePaywall}
                GetScrollValue={this.GetScrollValue}
                userType={userType}
                latestStories={this.state.latestStories}
                trendingStories={this.state.trendingStories}
                paywallPlans={paywallPlans}
                razaorpayKey={razaorpayKey}
                story={story}
                issueCollection={issueCollection}
                magazineEntity={magazineEntity}
                index={0}
                episodes={episodes}
              />
            )}
          </WithHostUrl>
          <div />
        </div>
        <React.Fragment>
          <VikatanSticky placement="story" storyId={storyId} story={story} config={this.props.config} />
          <VikatanDesktopSticky placement="story" storyId={storyId} story={story} config={this.props.config} />
        </React.Fragment>
      </React.Fragment>
    );
  }
}

StoryFeedPage.propTypes = {
  episodes: StoryHeader.propTypes.episodes,
  story: TextStory.propTypes.story,
  config: PropTypes.object,
  metypeConfig: PropTypes.object,
  recentStory: PropTypes.object,
  paywallPlans: PropTypes.object,
  razaorpayKey: PropTypes.object,
  firePageView: PropTypes.func,
  issueCollection: PropTypes.shape({
    id: PropTypes.number
  }),
  READMORE_ENABLE: PropTypes.bool,
  index: PropTypes.number,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  userType: PropTypes.string,
  actionhandleActivePaywall: PropTypes.func,
  activePaywall: PropTypes.bool,
  visualStories: PropTypes.shape(),
  actionhandleStdActivePaywall: PropTypes.func,
  GetScrollValue: PropTypes.func,
  activeStdPaywall: PropTypes.bool,
  latestStories: PropTypes.shape(),
  trendingStories: PropTypes.shape(),
  data: PropTypes.shape(),
  pageType: PropTypes.string,
  stickyShare: PropTypes.bool,
  clientSideRendered: PropTypes.bool
};
